(function (w, doc, undefined) {
	'use strict';

	let ARIAtoggle = {};
	w.ARIAtoggle = ARIAtoggle;

	let widgetClass = 'rs-toggle';
	let widgetHeadingClass = widgetClass + '__heading';
	let widgetTriggerClass = widgetClass + '__trigger';
	let widgetPanelClass = widgetClass + '__panel';

	let widgetHeading = '[data-aria-toggle-heading]';
	let widgetPanel = '[data-aria-toggle-panel]';

	let idCounter = 0;

	/**
	 * Create object.
	 */
	ARIAtoggle.create = function () {
		let self;
		let panels;
		let headings;
		let triggers;
		let defaultPanel;
		let constantPanel;
		let i;

		let widget = doc.querySelectorAll('[data-component="data-aria-toggle"]');

		idCounter += 1;

		for (i = 0; i < widget.length; i++) {
			self = widget[i];
			let t;

			// Setup toggle component ID
			if (!self.hasAttribute('id')) {
				self.id = 'tog_' + idCounter + '-' + i;
			}

			// Add toggle component class
			self.classList.add(widgetClass);

			// Determine default toggle panel open not required
			if (self.getAttribute('data-default') === '0') {
				defaultPanel = self.getAttribute('data-default');
			} else {
				defaultPanel = '1';
			}

			// Determine if accordion should always have a panel open
			constantPanel = self.hasAttribute('data-constant');

			// Get existing panels & headings
			panels = doc.querySelectorAll('#' + self.id + ' ' + widgetPanel);
			headings = doc.querySelectorAll('#' + self.id + ' ' + widgetHeading);

			// Setup panel & button.
			ARIAtoggle.setupPanels(self.id, panels, defaultPanel);
			ARIAtoggle.setupButtons(self.id, headings, defaultPanel, constantPanel);

			// Get current trigger
			triggers = doc.querySelectorAll('#' + self.id + ' .' + widgetTriggerClass);

			// Setup trigger events
			triggers[0].addEventListener('click', ARIAtoggle.clickEventListener);
		}
	}; // ARIAtoggle.create()

	/**
	 * Setup toggle panels.
	 */
	ARIAtoggle.setupPanels = function (id, panels, defaultPanel) {
		let panel;
		let panelID;

		panel = panels[0];

		// Add panel id
		panelID = id + '_panel_1';
		panel.setAttribute('id', panelID);

		// Add panel class
		panel.classList.add(widgetPanelClass);

		// Add aria role
		panel.setAttribute('role', 'region');

		// Add aria-labelledby
		panel.setAttribute('aria-labelledby', panelID + "_trigger");

		// Hide if not first panel
		if (defaultPanel !== '1') {
			panel.setAttribute('hidden', '');
		}

	}; // ARIAtoggle.setupPanels

	/**
	 * Setup toggle button.
	 */
	ARIAtoggle.setupButtons = function (id, headings, defaultPanel, constantPanel) {
		let heading;
		let newButton;
		let buttonText;
		let buttonID;

		heading = headings[0];

		buttonID = id + '_panel_1';

		// Add heading class
		heading.classList.add(widgetHeadingClass);

		// Create new button
		newButton = doc.createElement('button');
		buttonText = heading.textContent;
		heading.innerHTML = '';

		// Add the heading text
		heading.appendChild(newButton);
		newButton.appendChild(doc.createTextNode(buttonText));

		// Add button id
		newButton.setAttribute('id', buttonID + '_trigger');

		// Add button class
		newButton.classList.add(widgetTriggerClass);

		// Add aria-labelledby
		newButton.setAttribute('aria-controls', buttonID);

		// Determine default panel
		if (defaultPanel === '1') {
			// Expand the default panel
			newButton.setAttribute('aria-expanded', 'true');

			if (constantPanel) {
				// Prevent this panel being closed
				newButton.setAttribute('aria-disabled', 'true');
			}
		} else {
			newButton.setAttribute('aria-expanded', 'false');
		}
	}; // ARIAtoggle.setupButtons

	/**
	 * Handle click event.
	 */
	ARIAtoggle.clickEventListener = function (event) {
		let thisTrigger = event.target;

		ARIAtoggle.togglePanel(thisTrigger, true);
	}; // ARIAtoggle.clickEventListener

	/**
	 * Toggles a panel.
	 */
	ARIAtoggle.togglePanel = function (thisTrigger, setFocus) {
		setFocus = setFocus || true;

		let thisPanelID = thisTrigger.getAttribute('aria-controls');

		// Prevent action on disabled trigger
		if (thisTrigger.getAttribute('aria-disabled') !== 'true') {

			if (thisTrigger.getAttribute('aria-expanded') === 'false') {

				// Set expanded to true for this trigger
				thisTrigger.setAttribute('aria-expanded', 'true');

				// Remove hidden attribute from corresponding panel
				doc.getElementById(thisPanelID).removeAttribute('hidden');

				// Set focus if required
				if (setFocus) {
					thisTrigger.focus();
				}

			} else {
				thisTrigger.setAttribute('aria-expanded', 'false');

				// Add hidden attribute to panel
				doc.getElementById(thisPanelID).setAttribute('hidden', '');
			}
		}
	}; // ARIAtoggle.togglePanel

	ARIAtoggle.init = function () {
		ARIAtoggle.create();
	};

	ARIAtoggle.init();

})(window, document);
